export const V2_ZOOM_MIN = 0.5;
export const V2_ZOOM_MAX = 3;

/** 줌 프리셋(fit-page 기준 배율) */
export const V2_ZOOM_PRESETS = [0.5, 0.75, 1, 1.25, 1.5, 2, 3];

/**
 * 가로 맞춤 힌트 노출 임계값.
 * fit-page 렌더 폭이 가용 폭의 이 비율 미만이면 "세로로 긴 페이지"로 보고
 * 가로 맞춤 힌트 칩을 노출한다. 뷰어가 자동으로 배율을 바꾸지는 않는다.
 */
export const V2_FIT_WIDTH_HINT_THRESHOLD = 0.6;

/**
 * 힌트 노출 기준 fit-width 배율.
 * fitPageWidth < 임계비율 × availableWidth ⇔ fitWidthZoom > 1 / 임계비율
 */
export const V2_FIT_WIDTH_HINT_MIN_ZOOM = 1 / V2_FIT_WIDTH_HINT_THRESHOLD;

/** Ctrl/Cmd + 휠 연속 줌 감도 */
export const V2_WHEEL_ZOOM_INTENSITY = 0.0022;

/** 모바일 더블 탭 줌인 목표 배율(fit 기준). 재차 더블 탭 시 100%로 복귀 */
export const V2_DOUBLE_TAP_ZOOM = 2;

export const clampV2Zoom = (zoom: number) =>
  Math.min(V2_ZOOM_MAX, Math.max(V2_ZOOM_MIN, zoom));

/**
 * 핀치 종료 시 배율 스냅. 제스처 중에는 연속 배율로 부드럽게 움직이되,
 * 손을 뗄 때 5% 단위로 정리하고 100% 근접(±3%) 시 100%로 복귀시킨다.
 */
export const snapV2PinchZoom = (zoom: number) => {
  if (Math.abs(zoom - 1) <= 0.03) {
    return 1;
  }
  return clampV2Zoom(Math.round(zoom * 20) / 20);
};

/**
 * 이미지 sizes 힌트를 160px 단위로 양자화한다.
 * 연속 줌 중 srcset 후보가 매 프레임 재선택되는 스래싱을 막는다.
 */
export const quantizeImageSizes = (renderedWidth: number) =>
  `${Math.max(160, Math.ceil(renderedWidth / 160) * 160)}px`;

/** ± 버튼 스텝: 2.0까지는 0.25, 그 이상은 0.5 */
export const getNextZoomStep = (zoom: number, direction: 'in' | 'out') => {
  const step = (direction === 'in' ? zoom : zoom - 0.01) >= 2 ? 0.5 : 0.25;
  const next = direction === 'in' ? zoom + step : zoom - step;
  return clampV2Zoom(Math.round(next * 100) / 100);
};
